// extracted by mini-css-extract-plugin
export default {"select":"FormPostSelect_select__T2UNI"};